import { REQUEST_MESSAGES } from "../constants/requestMessages";
export const getSavedIndividuals = async (token) => {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/profile/saved-individuals`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(errorText || REQUEST_MESSAGES.FETCH_SAVED_INDIVIDUALS_FAILED);
  }

  return response.json();
};

export const getSavedAddresses = async (token, search = "") => {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/profile/saved-addresses?search=${encodeURIComponent(
      search
    )}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(errorText || REQUEST_MESSAGES.FETCH_SAVED_ADDRESSES_FAILED);
  }

  return response.json();
};

export const createSavedAddress = async (token, address) => {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/profile/saved-addresses`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ address }),
    }
  );

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error);
  }

  return data;
};

export const deleteSavedAddress = async (token, id) => {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/profile/saved-addresses/${id}`,
    {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error);
  }

  return data;
};